module.exports = __webpack_public_path__ + "img/appleStoreBg.5961e0b3.png";